<div class="col-12">
  <div class="hero-images">
    <div class="country-circle-img rotating">
      <img class="" src="../../../../assets/images/contry.png" alt="" />
    </div>
  </div>
  <div class="container swiperGalery">
    <div class="hero-image slider-container">
      <owl-carousel-o [options]="owlOptions" class="myOwlCarousel">
        <ng-container *ngFor="let slider of sliders">
          <ng-template carouselSlide>
            <div class="carousel-item-container">
              <div class="bg-slider-shadow"></div>
              <app-img-view [imageUrl]="slider.imageUrl" [imgAlt]="slider.title" [cssClass]="'detail-slide-img'"></app-img-view>

              <!-- <div class="carousel-caption">
                  <div class="slider-title">
                    <h3>{{ slider.title }}</h3>
                    <p>{{ slider.content }}</p>
                  </div>
                </div> -->
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</div>
